import { inIphone, inApp } from '@inv/base/es/platform'
import './fonts.scss'

function addCSSRule(sheet, selector, rules, index) {
  if ('insertRule' in sheet) {
    sheet.insertRule(selector + '{' + rules + '}', index)
  } else if ('addRule' in sheet) {
    sheet.addRule(selector, rules, index)
  }
}

// reset the font-family
if (inIphone && inApp) {
  // Create the <style> tag
  const style = document.createElement('style')

  // WebKit hack :(
  style.appendChild(document.createTextNode(''))

  // Add the <style> element to the page
  document.head.appendChild(style)

  addCSSRule(
    style.sheet,
    'html, body, div, p, span, h1, h2, h3, h4, ul, li, input, a, button, .card-header .card-header__title',
    'font-family: SFUIText, sans-serif;'
  )
}
